import { Panel } from '../../UI/Panel'
import { Draw } from '../../type/PixiType'
import { Image } from '../../UI/Image'
import { t } from '../../domain/language/languageUtil'
import { Container, Graphics, Text } from '@pixi/react'
import { TextStyle } from 'pixi.js'
import { BetHistoryHeaderCol } from './BetHistoryHeaderCol'
import { useCallback, useEffect, useMemo, useState } from 'react'
import { Loading } from '../Loading'
import { useBetHistoryStore } from '../../domain/betHistory/store/betHistoryStore'
import { ScrollBox } from '../../UI/ScrollBox'
import { BetHistoryRowData } from '../../domain/betHistory/model/BetHistoryRowData'
import { Button, FixedContainerV2 } from '../../UI'
import { formatToCommaWithLang } from '../../util/formatUtil'
import { soundManager, SoundType } from '../../domain/sound/SoundManager'

const DEFAULT_GAME_RESOLUTION = { width: 1920, height: 1080 }

interface BetHistoryProps {
  openBetDetail: (refNo: number, statementDate: string) => void
  gameResolution?: {
    width: number
    height: number
  }
  panelFitRatio?: number
}
const colTotalWidth = 992
const colWidth = colTotalWidth / 4
const colHeight = 44
const grayTextStyle = new TextStyle({
  fontSize: 30,
  fill: '#979797',
})
const normalTextStyle = new TextStyle({
  fontSize: 30,
  fill: '#FFFFFF',
})
const refnoStyle = new TextStyle({
  fill: '#ECC350',
  fontSize: 20,
  wordWrap: true,
  breakWords: true,
  wordWrapWidth: colWidth,
})
const textStyle = new TextStyle({
  fill: '#FFFFFF',
  fontSize: 20,
  wordWrap: true,
  breakWords: true,
  wordWrapWidth: colWidth,
})

const panelWidth = 1000
const panelHeight = 619

export const BetHistoryLandscape = ({
  gameResolution = DEFAULT_GAME_RESOLUTION,
  panelFitRatio = 1,
  openBetDetail,
}: BetHistoryProps) => {
  const betHistoryStore = useBetHistoryStore()
  const [panelScale, setPanelScale] = useState(1)
  const [panelPosition, setPanelPosition] = useState({ x: 0, y: 0 })
  const drawGrayBackground = useCallback<Draw>((g) => {
    g.clear()
    g.beginFill(0x000000, 0.8)
    g.drawRect(0, 0, 2000 * 2, 2000 * 2)
    g.endFill()
  }, [])

  const drawLine = useCallback<Draw>((g) => {
    g.clear()
    g.lineStyle(1, '#979797', 1)
    g.moveTo(20, 58)
    g.lineTo(300 - 20, 58)
  }, [])

  const drawTitleBg = useCallback<Draw>((graphics) => {
    const height = 63
    const radius = 20
    graphics.clear()
    graphics.beginFill('#333841')
    graphics.moveTo(0, radius)
    graphics.arc(radius, radius, radius, Math.PI, Math.PI * 1.5) // 左上圓角
    graphics.lineTo(panelWidth - 8 - radius, 0) // 頂部線條
    graphics.arc(panelWidth - 8 - radius, radius, radius, Math.PI * 1.5, 0) // 右上圓角
    graphics.lineTo(panelWidth - 8, height) // 右側線條
    graphics.lineTo(0, height) // 底部線條
    graphics.lineTo(0, radius) // 左側線條
    graphics.endFill()
  }, [])

  useEffect(() => {
    const gameAspectRatio = gameResolution.width / gameResolution.height
    const panelAspectRatio = panelWidth / panelHeight
    let scale = 1

    if (gameAspectRatio > panelAspectRatio) {
      scale = gameResolution.height / panelHeight * panelFitRatio
    }
    else {
      scale = gameResolution.width / panelWidth * panelFitRatio
    }

    setPanelScale(scale)
    setPanelPosition({ x: (gameResolution.width - panelWidth * scale) / 2, y: (gameResolution.height - panelHeight * scale) / 2 })
  }, [gameResolution, panelFitRatio])
  return (
    betHistoryStore.isOpened
      ? (
          <FixedContainerV2 name="GrayBackground" x={0} y={0} width={gameResolution.width} height={gameResolution.height}>
            <Graphics width={gameResolution.width} height={gameResolution.height} draw={drawGrayBackground} eventMode="static" />
            <Container x={panelPosition.x} y={panelPosition.y} scale={panelScale}>
              <Panel
                x={0}
                y={0}
                width={panelWidth}
                height={panelHeight}
                border={{
                  color: '#909090',
                  width: 4,
                }}
                radius={20}
                backgroundColor="#1F2328"
              >
                <Graphics draw={drawTitleBg} x={4} y={4} />
                <Text
                  text={t('betList_title')}
                  x={(panelWidth - 211) / 2}
                  y={13}
                  style={new TextStyle({
                    fontSize: 40,
                    fontWeight: 'bold',
                    fill: '#FFFFFF',
                  })}
                />
                <Button
                  name="close button123312213"
                  x={panelWidth - 60}
                  y={10}
                  enabled={true}
                  visible={true}
                  width={48}
                  height={48}
                  defaultView="close_normal"
                  hoverView="close_hover"
                  disabledView="close_disabled"
                  pressedView="close_click"
                  onPress={() => {
                    useBetHistoryStore.setState({ isOpened: false })
                    soundManager.play(SoundType.buttonClose)
                  }}
                />
                <Panel x={4} y={64} width={panelWidth - 8} height={colHeight} backgroundColor="#565A63">
                  <Container x={(panelWidth / 2) - 224} y={9}>
                    <Text
                      x={0}
                      text={betHistoryStore.startTime}
                      style={new TextStyle({
                        fill: '#FFFFFF',
                        fontSize: 25,
                      })}
                    />
                    <Text
                      x={210}
                      text="~"
                      style={new TextStyle({
                        fill: '#FFFFFF',
                        fontSize: 25,
                      })}
                    />
                    <Text
                      x={234}
                      text={betHistoryStore.endTime}
                      style={new TextStyle({
                        fill: '#FFFFFF',
                        fontSize: 25,
                      })}
                    />
                  </Container>
                </Panel>
                <BetHistoryHeader />
                <BetHistoryBody betList={betHistoryStore.betList} openBetDetail={openBetDetail} />

                <Panel
                  x={20}
                  y={480}
                  width={300}
                  height={121}
                  backgroundColor="#171717"
                  border={{ color: '#8E8E8E', width: 3 }}
                  radius={20}
                >
                  <Text
                    text={t('betList_total_record')}
                    x={300 / 2}
                    y={29}
                    anchor={[0.5, 0.5]}
                    style={grayTextStyle}
                  />
                  <Graphics draw={drawLine} />
                  <Text
                    text={betHistoryStore.betCount.toString()}
                    x={300 / 2}
                    y={90}
                    anchor={[0.5, 0.5]}
                    style={normalTextStyle}
                  />
                </Panel>
                <Panel
                  x={300 + 50}
                  y={480}
                  width={300}
                  height={121}
                  backgroundColor="#171717"
                  border={{ color: '#8E8E8E', width: 3 }}
                  radius={20}
                >
                  <Text
                    text={t('betList_stake')}
                    x={300 / 2}
                    y={29}
                    anchor={[0.5, 0.5]}
                    style={grayTextStyle}
                  />
                  <Graphics draw={drawLine} />
                  <Text
                    text={formatToCommaWithLang(betHistoryStore.totalStake).toString()}
                    x={300 / 2}
                    y={90}
                    anchor={[0.5, 0.5]}
                    style={normalTextStyle}
                  />
                </Panel>
                <Panel
                  x={(300 + 30) * 2 + 20}
                  y={480}
                  width={300}
                  height={121}
                  backgroundColor="#171717"
                  border={{ color: '#8E8E8E', width: 3 }}
                  radius={20}
                >
                  <Text
                    text={t('betList_payout')}
                    x={300 / 2}
                    y={29}
                    anchor={[0.5, 0.5]}
                    style={grayTextStyle}
                  />
                  <Graphics draw={drawLine} />
                  <Text
                    text={formatToCommaWithLang(betHistoryStore.totalPayout).toString()}
                    x={300 / 2}
                    y={90}
                    anchor={[0.5, 0.5]}
                    style={normalTextStyle}
                  />
                </Panel>
              </Panel>
            </Container>
          </FixedContainerV2>
        )
      : null
  )
}

const BetHistoryHeader = () => {
  const width = 992
  const height = 42
  const colWidth = width / 4

  return (
    <Panel x={4} y={108} width={width} height={height} backgroundColor="#393E47">
      <BetHistoryHeaderCol
        x={0}
        y={0}
        width={colWidth}
        height={height}
        text={t('betList_time')}
        fill="#FFFFFF"
        backgroundColor="#393E47"
        fontSize={22}
      />
      <BetHistoryHeaderCol
        x={colWidth}
        y={0}
        width={colWidth}
        height={height}
        text={t('betList_transaction')}
        fill="#FFFFFF"
        backgroundColor="#393E47"
        fontSize={22}
      />
      <BetHistoryHeaderCol
        x={colWidth * 2}
        y={0}
        width={colWidth}
        height={height}
        text={t('betList_stake')}
        fill="#FFFFFF"
        backgroundColor="#393E47"
        fontSize={22}
      />
      <BetHistoryHeaderCol
        x={colWidth * 3}
        y={0}
        width={colWidth}
        height={height}
        text={t('betList_payout')}
        fill="#FFFFFF"
        backgroundColor="#393E47"
        fontSize={22}
      />
    </Panel>
  )
}

interface BetHistoryBodyProps {
  betList: BetHistoryRowData[]
  openBetDetail: (refNo: number, statementDate: string) => void
}

const BetHistoryBody = (props: BetHistoryBodyProps) => {
  const [isLoading] = useBetHistoryStore(x => [x.isLoading])

  const children = useMemo(() => {
    return props.betList.map((item, index) => {
      return <BetHistoryRow key={index} x={0} y={index * colHeight} data={item} openBetDetail={props.openBetDetail} />
    })
  }, [props.betList, props.openBetDetail])

  return (
    <FixedContainerV2 name="Bet History Body" x={4} y={149} width={1000} height={290}>
      {
        isLoading
          ? <Loading x={panelWidth / 2} y={290 / 2} width={100} height={100} />
          : (
              <ScrollBox x={0} y={0} width={1180} height={290}>
                {children}
              </ScrollBox>
            )
      }
    </FixedContainerV2>
  )
}

interface BetHistoryRowProps {
  x: number
  y: number
  data: BetHistoryRowData
  openBetDetail: (refNo: number, statementDate: string) => void
}
const BetHistoryRow = (props: BetHistoryRowProps) => {
  const [isHovering, setIsHovering] = useState(false)

  return (
    <Container
      x={props.x}
      y={props.y}
      width={colTotalWidth}
      height={colHeight}
      eventMode="static"
      cursor="pointer"
      pointerup={() => {
        props.openBetDetail(props.data.refNo, props.data.statementDate)
        soundManager.play(SoundType.buttonConfirm)
      }}
      pointerover={() => {
        setIsHovering(true)
      }}
      pointerout={() => {
        setIsHovering(false)
      }}
    >
      <Panel name="BetHistoryRow" x={0} y={0} width={colTotalWidth} height={colHeight} backgroundColor={isHovering ? '#3B3D42' : '#565A63'}>
        <Panel x={colWidth} y={0} width={colWidth} height={colHeight} backgroundColor={isHovering ? '#323438' : '#494C53'} />
        <Panel x={colWidth * 3} y={0} width={colWidth} height={colHeight} backgroundColor={isHovering ? '#323438' : '#494C53'} />
        <Text text={props.data.orderTime} x={colWidth / 2} y={colHeight / 2} anchor={0.5} style={textStyle} />
        <Text
          text={props.data.refNo.toString()}
          x={colWidth / 2 + colWidth}
          y={colHeight / 2}
          anchor={0.5}
          style={refnoStyle}
        />
        <Text
          text={formatToCommaWithLang(props.data.stake).toString()}
          x={colWidth / 2 + colWidth * 2}
          y={colHeight / 2}
          anchor={0.5}
          style={textStyle}
        />
        <Text
          text={formatToCommaWithLang(props.data.payout).toString()}
          x={colWidth / 2 + colWidth * 3}
          y={colHeight / 2}
          anchor={0.5}
          style={textStyle}
        />
        <Image
          x={colWidth * 4 - 40}
          y={10}
          width={17}
          height={27}
          image="btn_next"
        />
      </Panel>
    </Container>
  )
}
